import { useMutation } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import { axiosForAnonymousHudson } from '@telialt/utils/src/axios/axiosForAnonymousHudson';

import { API } from '../constants';
import { FeedbackSubmitData } from '../model';

export const apiPostSendFeedback = (data: FeedbackSubmitData) =>
    axiosForAnonymousHudson.post(API.URL_POST_FEEDBACK, data);

export const useSubmitFeedback = () => {
    return useMutation<AxiosResponse, unknown, FeedbackSubmitData>({
        mutationFn: apiPostSendFeedback,
    });
};
